import { OutlinedInput, Select as SelectMui } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { NoOptionItem } from './components/NoOptionItem'
import { optionToMenuItem } from './components/optionToMenuItem'
import { SelectContainer } from './components/SelectContainer'
import { SelectOption, SelectProps } from './types'
import { optionsWithNone } from './utils/optionsWithNone'

export const Select = <T,>({
  disabled,
  disabledOptions,
  error,
  helperText,
  label,
  labelColor,
  name,
  optional,
  options,
  size,
  tooltip,
  value,
  ...props
}: SelectProps<T>): JSX.Element => {
  const { t } = useTranslation('components')

  const allOptions: SelectOption<T>[] = optionsWithNone({ optional, options, t })

  return (
    <SelectContainer<T> {...{ disabled, error, helperText, label, name, tooltip }}>
      <SelectMui
        {...props}
        disabled={disabled}
        id={name}
        input={
          <OutlinedInput
            label={label}
            notched
          />
        }
        labelId={`${name}-label`}
        name={name}
        sx={theme => ({ backgroundColor: theme.palette.white.main })}
        value={options.length > 0 ? value : ''}
      >
        {allOptions.length ? (
          allOptions.map(
            ({ endAdornment, label, logo, value }: SelectOption<T>): JSX.Element =>
              optionToMenuItem<T>({
                disabledOptions,
                endAdornment,
                label,
                labelColor,
                logo,
                size,
                value,
              }),
          )
        ) : (
          <NoOptionItem t={t} />
        )}
      </SelectMui>
    </SelectContainer>
  )
}
